import { Divider, Group } from '@byecode/ui'
import type { WechatRefundConfig } from '@lighthouse/core'
import type { FlowNode, NodeTypes, WeChatRefundActionConfig } from '@lighthouse/shared'
import { ListItem4ByecodeUi, OUTPUT_SINGLE_DATA_NODES, OUTPUT_SINGLE_RECORD_NODES, useAtomData } from '@lighthouse/shared'
import React, { useMemo } from 'react'

import { WechatPaymentAccountSelect } from '@/components/WechatPaymentAccountSelect'
import { useFlowContainerContext } from '@/contexts/FlowContext'

import * as CM from '../../styles'
import { SelectRecordControlled } from '../component/SelectRecordControlled'
import Refund from './Refund'

interface WeChatRefundActionConfigureProps {
    nodeType?: NodeTypes
    allParentNodes?: FlowNode[]
    actionTypeSwitcher?: React.ReactNode
    value: WeChatRefundActionConfig
    onChange: (value: WeChatRefundActionConfig) => void
}

export const WeChatRefundActionConfigure: React.FunctionComponent<WeChatRefundActionConfigureProps> = ({
    actionTypeSwitcher,
    allParentNodes,
    value,
    onChange
}) => {
    const { type } = useFlowContainerContext()
    const isWorkflow = !!type

    const upstreamNodesForVariableSelect = useMemo(
        () => allParentNodes?.filter(item => OUTPUT_SINGLE_DATA_NODES.has(item.data.nodeType)),
        [allParentNodes]
    )
    const upstreamNodesForSource = useMemo(
        () => allParentNodes?.filter(item => OUTPUT_SINGLE_RECORD_NODES.has(item.data.nodeType)),
        [allParentNodes]
    )

    const header = useMemo(() => {
        if (!actionTypeSwitcher) {
            return null
        }
        return (
            <>
                <Group label="动作配置">
                    <ListItem4ByecodeUi>
                        <CM.FormItemLabelWrapper>
                            <CM.FormItemLabel>类型</CM.FormItemLabel>
                        </CM.FormItemLabelWrapper>
                        <CM.FormItemContent>{actionTypeSwitcher}</CM.FormItemContent>
                    </ListItem4ByecodeUi>
                </Group>
                <Divider />
            </>
        )
    }, [actionTypeSwitcher])

    return (
        <CM.Container>
            {header}
            <WechatPaymentAccountSelect
                value={value?.paymentAccountId}
                onChange={paymentAccountId => onChange({ ...value, paymentAccountId })}
            />
            <Divider />
            <Group label="选择退款订单">
                <SelectRecordControlled
                    value={value}
                    onChange={val => onChange(val as WechatRefundConfig)}
                    upstreamNodesForVariableSelect={upstreamNodesForVariableSelect}
                    upstreamNodesForSource={upstreamNodesForSource}
                    upstreamRecordIsFilterAndSort={false}
                    disableUpstreamRecord={!isWorkflow}
                />
            </Group>
            <Divider color="var(--color-gray-200)" />
            <Refund allParentNodes={allParentNodes} value={value} onChange={onChange} />
        </CM.Container>
    )
}
